import axios from "../lib/axios"; 

const checkAndLock = async (DocId , tableName,Where) => {
    const UserId = sessionStorage.getItem("UserId");

    try { 
        let response = await axios.post(
            `Lock/GetLockData`,
            {
                "tblName": tableName,
                "ColName1": "LockId",
                "Cwhere": Where,
                "LockId": parseInt(UserId),
                "DocId": DocId,
                "UserID": parseInt(UserId)
            }
        );

        if (response.data.Status === 0) {
            try {    
                let response = await axios.post(
                    `Lock/UpdateLock`,
                    {
                        "tblName": tableName,
                        "LockSt": "1",
                        "LockId": parseInt(UserId),
                        "Cwhere": Where,
                        "LockDt": "2024-11-27 17:30:01.743",
                        "DocId": DocId,
                        "Flag": "",
                        "ColName": "LockSt",
                        "ColName1": "LockId",
                        "ColName2": "LockDt"
                    }
                );

                if (response.data.Status === 0) {
                    return 0;
                } else {
                    return 2;
                }
            } catch (err) {
                console.log("Error in UpdateLock:", err);
            }
        } else {
            return 1;
        }
    } catch (err) {
        console.log("Error in GetLockData:", err);
    }
};

export default checkAndLock;